<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("product.商品名称") }}</th>
            <th>SKU</th>
            <th>{{ $t("other.仓位") }}</th>
            <th>{{ $t("warehouse.货架") }}</th>
            <th>{{ $t("order.数量") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <span class="tx-white">{{ item.skuName }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.sku }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.positionName }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.shelfName }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.quantity }}</span>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="9">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的数据") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
};
</script>